var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12H11C11.2651 11.9997 11.5193 11.8942 11.7068 11.7068C11.8942 11.5193 11.9997 11.2651 12 11V1C11.9997 0.734877 11.8942 0.4807 11.7068 0.293229C11.5193 0.105759 11.2651 0.000304367 11 0H1C0.734877 0.000304367 0.4807 0.105759 0.293229 0.293229C0.105759 0.4807 0.000304367 0.734877 0 1V11C0.000304367 11.2651 0.105759 11.5193 0.293229 11.7068C0.4807 11.8942 0.734877 11.9997 1 12ZM1 11V1H11L11.0006 11H1ZM6.5 2.5H5.5V7H6.5V2.5ZM6 8C5.85166 8 5.70666 8.04399 5.58332 8.1264C5.45999 8.20881 5.36386 8.32594 5.30709 8.46299C5.25033 8.60003 5.23547 8.75083 5.26441 8.89632C5.29335 9.0418 5.36478 9.17544 5.46967 9.28033C5.57456 9.38522 5.7082 9.45665 5.85368 9.48559C5.99917 9.51453 6.14997 9.49967 6.28701 9.44291C6.42406 9.38614 6.54119 9.29001 6.6236 9.16668C6.70601 9.04334 6.75 8.89834 6.75 8.75C6.75 8.55109 6.67098 8.36032 6.53033 8.21967C6.38968 8.07902 6.19891 8 6 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSquare);
export default __webpack_public_path__ + "static/media/infoSquare.853a7bbe45e83af05594a08c126bd238.svg";
export { ForwardRef as ReactComponent };